/**
 * 主页折扣标识
 * */
import React from 'react';
import { Popover } from 'antd';
import store from '../../../store/store';
import './DiscountsTip.scss';
import Util from '../../../script/util';

/* 八元 图标 */
const PopoverEight = () => {
  const { rootConfig } = store.getState();
  const lang = rootConfig?.lang === 'zh_TW';
  const priceText = lang ? `${8 * 100}钻` : `8元`;
  const renderContent = () => {
    return (
      <div className="eight-discount-tip">
        <h5 className="title">
          每个用户每天只能下1次{priceText}体验单。{priceText}按照局结算。
        </h5>
        <p className="tip">
          例如：大神的王者荣耀资质参与活动，则用户可以在大神的主页下单王者荣耀服务
          {priceText}/局。
        </p>
      </div>
    );
  };

  return (
    <Popover rootClassName="daidai-popover-default" content={renderContent()}>
      <span className={Util.classNames('eight-give-ban', { tw: lang })} />
    </Popover>
  );
};

/* 买二送一 图标  */
const PopoverGiveFull = () => {
  const renderContent = () => {
    return (
      <div className="give-full-discount-tip">
        <h5 className="title">
          用户每日首单即可享受。当下单数量≥3单，订单金额自动优惠1单。
        </h5>
      </div>
    );
  };

  return (
    <Popover rootClassName="daidai-popover-default" content={renderContent()}>
      <span className="full-give-ban" />
    </Popover>
  );
};

/* 单价 */
const SkillUnitPrice = ({ lang, price }) => {
  return (
    <div className="skill-unit-price">
      <span className="text">单价</span>
      {lang !== 'zh_CN' && (
        <>
          <span className="price tw">{price * 100}</span>
          <span className="d-icon" />
        </>
      )}

      {lang === 'zh_CN' && (
        <>
          <span className="unit">￥</span>
          <span className="price">{price}</span>
        </>
      )}
    </div>
  );
};

export { PopoverEight, PopoverGiveFull, SkillUnitPrice };
